import React, { useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import styles from "./Plan.module.sass";
import Icon from "../../../components/Icon";

const options = [
  {
    title: "Fonctionnalités principales",
    items: [
      {
        title: "Nombre de contrats / dossiers",
        description: "Volume de contrats d'apprentissage pouvant être traités",
      },
      {
        title: "Tableau de bord",
        description: "Interface centralisée pour suivre tous vos contrats d'apprentissage avec alertes automatiques",
      },
      {
        title: "Gestion des contrats",
        description: "Gestion des contrats d'apprentissage",
      },
      {
        title: "Signature électronique",
        description: "Processus de signature numérique sécurisé pour tous les acteurs du contrat",
      },
      {
        title: "Génération des documents officiels",
        description: "Génération automatique des documents officiels avec pré-remplissage intelligent",
      },
      {
        title: "Gestion des procédures de rupture",
        description: "Gestion automatisée des procédures de rupture de contrat",
      },
      {
        title: "Suivi OPCO",
        description: "Transmission automatique des dossiers complets aux organismes de financement",
      },
      {
        title: "Facturation et échéanciers",
        description: "Système de facturation intégré avec gestion des échéanciers de paiement",
      },
      {
        title: "Module d'émargement",
        description: "Système d'émargement et suivi des heures d'apprentissage (rapport absences, rapport assiduité, etc.)",
      },
      {
        title: "Module de prospection",
        description: "Outils de prospection et de développement commercial intégrés (Entreprise, Etudiant, Offre d'emploi, etc.)",
      },
      {
        title: "Module de reporting",
        description: "Tableaux de bord et rapports détaillés pour le suivi de performance",
      },
      {
        title: "Support client (SAV)",
        description: "Assistance technique et fonctionnelle (self-service, standard, prioritaire ou premium)",
      },
    ],
  },
];

const data = [
  {
    title: "Démo (Gratuit)",
    color: "#39CD54",
    //description: "Pour tester notre solution",
    price: "0",
    note: "essai gratuit (14 jours)",
    button: "Commencer l'essai",
    options: [
      "5",
      "true",
      "true",
      "true",
      "true",
      "false",
      "false",
      "false",
      "false",
      "false",
      "false",
      "false",
    ],
  },
  {
    title: "Starter",
    color: "#FDCB6E",
    //description: "Idéal pour petits organismes",
    price: "149",
    note: "€/mois (10 contrats inclus)",
    button: "Choisir Starter",
    options: [
      "10",
      "true",
      "true",
      "true",
      "true",
      "true",
      "false",
      "false",
      "false",
      "false",
      "false",
      "Standard",
    ],
  },
  {
    title: "Standard",
    color: "#39B7CD",
    //description: "Pour organismes de taille moyenne",
    price: "299",
    note: "€/mois (30 contrats inclus)",
    button: "Choisir Standard",
    options: [
      "30",
      "true",
      "true",
      "true",
      "true",
      "true",
      "true",
      "true",
      "false",
      "false",
      "✔ (basique)",
      "Prioritaire (email + téléphone)",
    ],
  },
  {
    title: "Pro / Avancée",
    color: "#CABDFF",
    //description: "Pour grands organismes",
    price: "599",
    note: "€/mois (100 contrats inclus)",
    button: "Choisir Pro",
    featured: true,
    options: [
      "100",
      "true",
      "true",
      "true",
      "true",
      "true",
      "true",
      "true",
      "true",
      "true",
      "✔ (avancé + exports)",
      "Premium (dédié + SLA)",
    ],
  },
];

const Plan = () => {
  const [more, setMore] = useState([false, false, false, false]);

  const handleClick = (index) => {
    let newMore = [...more];
    newMore[index] = !more[index];

    setMore(newMore);
  };

  const renderContent = (content) => {
    if (content === "true") {
      return <Icon name="check" size="14" />;
    }
    if (content === "false") {
      return <div className={styles.minus}>-</div>;
    }
    if (content.startsWith("✔")) {
      return <div className={styles.checkText}>{content}</div>;
    }
    if (content.startsWith("–")) {
      return <div className={styles.minus}>{content}</div>;
    }
    return <div className={styles.value}>{content}</div>;
  };

  return (
    <div className={cn("section-bg", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={cn("stage", styles.stage)}>
          Choisissez votre solution Edutio
        </div>
        <h1 className={cn("h1", styles.title)}>
          Des forfaits adaptés à vos besoins
        </h1>
        <div className={styles.table}>
          <div className={styles.row}>
            <div className={styles.col}>
              <div className={styles.head}></div>
              <div className={styles.body}>

                {options.map((option, index) => (
                  <div className={styles.item} key={index}>
                    <div className={styles.category}>{option.title}</div>
                    {option.items.map((item, index) => (
                      <div className={styles.parameter} key={index}>
                        <div className={styles.label}>{item.title}</div>
                        <div className={styles.hint}>
                          <Icon name="info" size="10" />
                          <div className={styles.tooltip}>
                            {item.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
            {data.map((type, index) => (
              <div className={styles.col} key={index}>
                <div className={styles.head}>
                  <div className={styles.package} style={{ color: type.color }}>
                    {type.title}
                  </div>
                  <div className={styles.description}>{type.description}</div>
                  {type.price && (
                    <>
                      <div className={styles.cost}>
                        <span className={styles.price}>{type.price}</span>
                        <span className={styles.sign}>€</span>
                      </div>
                      <div className={styles.note}>{type.note}</div>
                    </>
                  )}
                </div>
                <div className={styles.body}>
                  <div
                    className={cn(styles.more, {
                      [styles.active]: more[index],
                    })}
                    onClick={() => handleClick(index)}
                  >
                    Voir toutes les fonctionnalités
                    <Icon name="arrow-bottom" size="9" />
                  </div>
                  <div
                    className={cn(styles.list, {
                      [styles.visible]: more[index],
                    })}
                  >
                    {options.map((option, optionIndex) => (
                      <div className={styles.item} key={optionIndex}>
                        {option.items.map((item, itemIndex) => (
                          <div className={styles.parameter} key={itemIndex}>
                            <div className={styles.label}>{item.title}</div>
                            {renderContent(type.options[itemIndex])}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                  <Link
                    to="/contact"
                    className={cn(
                      { button: index === 0 },
                      { button: index === 1 },
                      { button: index === 2 },
                      { "button-stroke": index === 3 },
                      styles.button
                    )}
                  >
                    {type.button}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plan;
